import moment from 'moment'

export function formatOverlapTrigger(trigger) {
  const labels = {
    periodic: 'Periodic job',
    inline_recheck: 'Inline re-check',
    manual_recheck: 'Manual re-check',
    planned_overlap: 'Planned overlap',
  }
  return labels[trigger] || trigger || ''
}

export function displayOverlapValue(value) {
  if (value === null || value === undefined || value === '')
    return '(none)'
  if (typeof value === 'object')
    return JSON.stringify(value)
  return String(value)
}

export function formatOverlapSource(source) {
  if (!source)
    return ''
  const parts = []
  if (source.event) parts.push('event: ' + source.event)
  if (source.lane) parts.push('lane: ' + source.lane)
  if (source.boundary_source) parts.push('boundary: ' + source.boundary_source)
  if (source.boundary_iso) parts.push('boundary time: ' + source.boundary_iso)
  if (source.peer_booking_id) parts.push('peer: ' + source.peer_booking_id)
  if (source.movement_id) parts.push('movement: ' + source.movement_id)
  if (source.driver_name) parts.push('driver: ' + source.driver_name)
  return parts.join(' | ')
}

export function formatOverlapProcessedTime(processedTime) {
  if (!processedTime)
    return ''
  const m = moment(processedTime)
  return m.isValid() ? m.format('MM-DD-YYYY h:mm A') : String(processedTime)
}

export function mapOverlapChanges(changes) {
  return (changes || []).map(c => ({
    label: c.field,
    old: displayOverlapValue(c.before),
    new: displayOverlapValue(c.after),
    sourceText: formatOverlapSource(c.source),
  }))
}

export function hasOverlapCorrection(item) {
  return !!(item && item.overlap_updates && item.overlap_updates.length)
}
